module.exports = __webpack_public_path__ + "img/hontai_VannillaWhite.50d1d56e.png";